// transform FROM Logged Out TO Logged Out (don't log in because user still needs to 2fa if applicable)

import { AuthState, isResetPasswordState } from "./authState";
import { Updater, any, nothing, wait, Widget } from 'widgets-for-react';
import { Api, reset_password, } from "./api_to_state";
import { reset_password_form, reset_password_success } from "./reset_password_form";
import { options } from "./utils";

export function resetPassword(
  options: options,
  api: Api,
  s0: AuthState,
  onContact: JSX.Element
): Widget<Updater<AuthState>> {
    const search = new URLSearchParams(location.search)
    const email = search.get("email") ?? '';
    const token = search.get("token") ?? '';
    if (isResetPasswordState(s0)) {
      return any<Updater<AuthState>>([
          s0.resetPasswordState == "reset password" ?
            reset_password_form(options, s0, false, api, onContact, false) :
          s0.resetPasswordState == "reset password - error weak password" || 
          s0.resetPasswordState == "reset password - error too many attempts" ||
          s0.resetPasswordState == "reset password - error token not valid" ?
            reset_password_form(options, s0, false, api, onContact, true) :
          s0.resetPasswordState == "reset password - api error" ?
            any<Updater<AuthState>>([
              wait(500, { key: "login-widget-reset-password-error-promise" })(() => (s : AuthState) : AuthState => isResetPasswordState(s) && s.resetPasswordState != "reset password - api error" ? s : ({...s, resetPasswordState:"reset password - resetting password"})),
              reset_password_form(options, s0, true, api, onContact, true)
            ]) :
          s0.resetPasswordState == "reset password - resetting password" ?
            any<Updater<AuthState>>([
              reset_password(api, {...s0.login_data, email, reset_password_token: token, password: s0.login_data.password}),
              reset_password_form(options, s0, true, api, onContact, false)
            ]) :            
            s0.resetPasswordState == 'reset password success' ?
              reset_password_success(options) :
          nothing()
      ])
    } else {
      return nothing()
    }
}